import PaddedLayout from 'layout/MainLayout/PaddedLayout';

import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import TeamsTable from './TeamsTable';

const TeamsListPage = () => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'teams.teams'}
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={['CREATE.TEAMS']}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn(`/team/new`)}
                                labelId="teams.add-new-team"
                                newLabelId="new-entity.team"
                            />
                        </div>
                    }
                />
                <TeamsTable />
            </div>
        </PaddedLayout>
    );
};

export default TeamsListPage;
